import Serializable from "Serializable";

class TabAiInsightsSettings extends Serializable {
  constructor() {
    super();
    this.selectedCategory = null;
    this.selectedSubCategoryId = null;
  }

  onSeralisedInfoRecieved(serializedValue) {
    this.selectedCategory = serializedValue.selectedCategory ? serializedValue.selectedCategory : null;
    this.selectedSubCategoryId = serializedValue.selectedSubCategoryId ? serializedValue.selectedSubCategoryId : null;
  }

  getDataObject() {
    return {
      selectedCategory: this.selectedCategory,
      selectedSubCategoryId: this.selectedSubCategoryId
    };
  }

  getObjectMapKey() {
    return "TabAiInsightsSettings";
  }
}

export default TabAiInsightsSettings;
